<template>
  <div>
    <edit-subscription-popup
      :subscription-to-edit="subscriptionToEdit"
      :data-to-show="isPopupEditSubscriptionDisplayed"
      @close="changeStateEditSubscriptionPopup(false)"
    />
    <edit-administrateur-payeur-popup
      :admin-to-edit="adminToEdit"
      :data-to-show="isPopupEditAdministrateurPayeurDisplayed"
      @close="changeStateEditAdministrateurPayeurPopup(false)"
    />
    <list-accounts-to-connect
      :data-to-show="isPopupListAccountsToConnectDisplayed"
      :structure="selectedStructure"
      :accounts="flatUsers(selectedStructure)"
      @close="changeStateListAccountsPopup(false)"
    />
    <div
      class="hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
    >
      <div class="px-12">
        <p class="text-4xl text-gray-900">
          Administration des abonnements
        </p>
        <p
          class="mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 xl:pr-72"
        >
          Cras ultricies ligula sed magna dictum porta. Vestibulum ac diam sit
          amet quam vehicula elementum sed sit amet dui. Vivamus magna justo,
          lacinia eget consectetur sed, convallis at tellus.
        </p>
      </div>
      <illustration
        name="Group189"
        class="hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72"
      />
    </div>
    <div>
      <!-- Contenu -->
      <div class="flex flex-col mt-16 mb-16">
        <div class="-my-2 py-2">
          <div
            class="relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
          >
            <h3 class="mt-15 mb-10 lg:mb-15 w-full">
              Abonnements
            </h3>

            <div class="text-center text-gray-600 cursor-pointer">
              <div
                @click="changeTab('structures')"
                class="text-2xl inline-block hover:text-pink-600 font-light"
                :class="{
                  'text-indigo-600 font-normal': tabDisplay == 'structures',
                }"
              >
                Structures
              </div>

              <div
                @click="changeTab('particuliers')"
                class="text-2xl inline-block sm:ml-5 xl:ml-10 hover:text-pink-600 font-light"
                :class="{
                  'text-indigo-600 font-normal': tabDisplay == 'particuliers',
                }"
              >
                Particuliers
              </div>
            </div>

            <!-- Content -->

            <!-- BEGIN add new + search + sort -->
            <div
              class="flex content-center items-center justify-between my-15 2xl:my-20 m-5 lg:mx-15 2xl:mx-20"
            >
              <div
                class="relative w-full sm:w-1/4 text-gray-400 focus-within:text-gray-600 border border-gray-200"
              >
                <input
                  id="search_field"
                  class="block w-full px-4 py-3 2xl:px-5 2xl:py-4 shadow-md rounded-md text-gray-900 placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 text-sm"
                  :placeholder="
                    'Rechercher ' +
                      (tabDisplay === 'structures'
                        ? 'une structure'
                        : 'un particulier')
                  "
                  type="search"
                  v-model="search"
                />
                <div
                  v-show="!search"
                  class="absolute mr-2 inset-y-0 right-0 flex items-center pointer-events-none text-indigo-600"
                >
                  <icon
                    name="search"
                    class="h-3 w-3 mr-1 sm:h-4 sm:w-4 sm:mr-1.5"
                  />
                </div>
              </div>

              <checkbox-indigo
                :is-checkbox-right="true"
                :value="showInactive"
                libelle="Afficher les comptes inactifs"
                name="inactiveAccounts"
                @input="
                  (newValue) => {
                    showInactive = newValue;
                  }
                "
              />

              <!-- BEGIN Search engine and alphabetic order -->
              <sort-button
                :sort="sort"
                @sorted="
                  (sortType) => {
                    sort = sortType;
                  }
                "
              />
              <!-- END Search engine and alphabetic order -->
            </div>
            <!-- END add new + search + sort -->

            <list-grid
              v-if="tabDisplay === 'structures'"
              :list-items="subscriptions"
              is-accordion-items
              :loading="loading"
            >
              <template #header>
                <div class="col-span-6 ml-15">
                  Type d'abonnement
                </div>
                <div class="col-span-6">
                  Nombre de structures
                </div>
              </template>
              <template #accordionDescription="{item, num}">
                <div class="col-span-6 ml-15">
                  {{ item }}
                </div>
                <div class="col-span-6">
                  {{ structuresSort.filter(s => s.subscription === item).length }}
                </div>
              </template>
              <template #accordionContent="{item, num}">
                <list-grid
                  :list-items="structuresSort.filter(
                    (s) => tabDisplay === 'structures' && s.subscription === item
                  )"
                  is-accordion-items
                  grid="grid-cols-10 border-l-2 border-indigo-600"
                >
                  <template #header>
                    <div
                      class="ml-16"
                      :class="{
                        'col-span-2': tabDisplay === 'structures',
                        'col-span-8': tabDisplay === 'particuliers',
                      }"
                    >
                      Nom
                    </div>
                    <div
                      v-if="tabDisplay === 'structures'"
                      class="col-span-3 xl:col-span-2"
                    >
                      Administrateur
                    </div>
                    <div
                      v-if="tabDisplay === 'structures'"
                      class="col-span-2"
                    >
                      Référents/Bénéficiaires
                    </div>
                    <div
                      v-if="tabDisplay === 'structures'"
                      class="col-span-2"
                    >
                      Date expiration
                    </div>
                    <div class="col-span-2">
                      Actions
                    </div>
                  </template>
                  <template #accordionDescription="{item: structure, num: index}">
                    <div class="ml-16 col-span-2">
                      <p class="text-base">
                        {{ structure.name }}
                        <span class="text-pink-600">
                          {{
                            new Date(structure.expiry_date) <= new Date()
                              ? ' (Inactif)'
                              : ''
                          }}
                        </span>
                      </p>
                      <p class="text-sm text-gray-600">
                        Créé le
                        {{ new Date(structure.created_at).toLocaleDateString('fr') }}
                      </p>
                    </div>
                    <div class="col-span-3 xl:col-span-2">
                      <p class="text-base">
                        {{ structure.admin ? structure.admin.firstname : 'Inconnu' }}
                        {{ structure.admin ? structure.admin.lastname : 'Inconnu' }}
                      </p>
                      <p class="text-sm text-gray-600">
                        {{ structure.admin ? structure.admin.email : 'Inconnu' }}
                      </p>
                    </div>
                    <div class="col-span-2">
                      {{ (structure.users?.manager?.length ?? '0') +'/'+ (structure.users?.beneficiary?.length ?? '0') }}
                    </div>
                    <div class="col-span-2">
                      {{
                        structure.expiry_date === null
                          ? ''
                          : new Date(structure.expiry_date).toLocaleDateString('fr')
                      }}
                    </div>
                    <div class="col-span-2 flex space-x-1">
                      <!-- TODO fix content for 2 next circle buttons -->
                      <!-- <circle-button
                        v-if="
                          structure.expiry_date &&
                          new Date(structure.expiry_date) < new Date()
                        "
                        icon="layers"
                        label="Gestion de l'abonnement"
                        @buttonClick="editSubscription(structure)"
                      /> -->
                      <!-- <circle-button
                        v-if="
                          tabDisplay === 'particuliers' ||
                          structure.list_payers.length > 0 ||
                          structure.admin_entreprise.length > 0
                        "
                        icon="person"
                        label="Gestion des informations de la structure"
                        @buttonClick="
                          tabDisplay === 'structures'
                            ? editAdmin(
                                structure.list_payers.length > 0
                                  ? structure.list_payers[0]
                                  : structure.admin_entreprise[0]
                              )
                            : editAdmin(structure.all_neopass[0])
                        "
                      /> -->
                      <circle-button
                        icon="monitor"
                        label="Accéder à l'interface Neopass de la structure"
                        @buttonClick="changeStateListAccountsPopup(true, structure)"
                      />
                    </div>
                  </template>
                  <template #accordionContent="{item: structure, num}">
                    <pre>{{ structure }}</pre>
                  </template>
                </list-grid>
              </template>
            </list-grid>



            <div
              v-if="
                (tabDisplay === 'particuliers' && particuliers.length === 0)
              "
              class="flex items-center justify-center w-full"
            >
              <span
                class="w-5 h-5 rounded-full border-t-2 border-r animate-spin border-gray-600"
              />
            </div>

            <div
              v-if="
                (tabDisplay === 'particuliers' && particuliers.length > 0)
              "
              class="h-16 lg:h-24 2xl:h-32 text-lg text-gray-600 grid grid-cols-10 gap-x-4 place-content-center mt-10"
            >
              <div
                class="ml-15"
                :class="{
                  'col-span-2': tabDisplay === 'structures',
                  'col-span-8': tabDisplay === 'particuliers',
                }"
              >
                Nom
              </div>
              <div
                v-if="tabDisplay === 'structures'"
                class="col-span-3 xl:col-span-2"
              >
                Administrateur
              </div>
              <div
                v-if="tabDisplay === 'structures'"
                class="col-span-2"
              >
                Type d'abonnement
              </div>
              <div
                v-if="tabDisplay === 'structures'"
                class="col-span-2"
              >
                Date expiration
              </div>
              <div class="col-span-2">
                Actions
              </div>
            </div>

            <div
              v-for="(particulier, idParticulier) in particuliersSort.filter(
                (s) => tabDisplay === 'particuliers'
              )"
              :key="'particulier' + idParticulier"
              class="h-16 lg:h-24 2xl:h-32 text-base bg-white even:bg-gray-200 even:bg-opacity-50 grid grid-cols-10 gap-x-4 place-content-center items-center"
            >
              <div class="col-span-8 ml-15">
                <p class="text-base">
                  {{ particulier.firstname }} {{ particulier.lastname }}
                </p>
                <p class="text-sm text-gray-600">
                  Créé le
                  {{
                    new Date(particulier.created_at).toLocaleDateString('fr')
                  }}
                </p>
              </div>
              <div class="col-span-2">
                <circle-button
                  icon="monitor"
                  label="Accéder à l'interface Neopass du particulier"
                  @buttonClick="connectToAccount(particulier)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import axios from '../../api';
import Constants from './../../constants';
import Icon from './../../components/Icon';
import CircleButton from './../../components/CircleButton';
import Illustration from './../../components/Illustration';
import CheckboxIndigo from './../../components/Inputs/CheckboxIndigo';
import SortButton from './../../components/SortButton';

import EditSubscriptionPopup from './../../components/Abonnements/EditSubscriptionPopup.vue';
import EditAdministrateurPayeurPopup from './../../components/Abonnements/EditAdministrateurPayeurPopup.vue';

import ClickOutside from 'vue-click-outside';
import ListAccountsToConnect from './popup/ListAccountsToConnect.vue';
import ListGrid from '../../components/AccordionTable/ListGrid.vue';

export default {
  components: {
    ListGrid,
    Icon,
    CircleButton,
    Illustration,
    CheckboxIndigo,
    SortButton,
    EditSubscriptionPopup,
    EditAdministrateurPayeurPopup,
    ListAccountsToConnect,
  },

  name: 'AbonnementsListSuperAdmin',

  data() {
    return {
      constants: Constants,

      tabDisplay: 'structures',
      structures: [],
      particuliers: [],
      selectedStructure: {},
      dataToShowSubscription: false,
      showInactive: false,
      sort: 'ABC',
      plans: {
        yearly: [
          process.env.MIX_OLD_PRICE_PLAN_YEARLY,
          process.env.MIX_PRICE_PLAN_YEARLY,
        ],
        monthly_with_commitment: [
          process.env.MIX_OLD_PRICE_PLAN_MONTHLY_WITH_COMMITMENT,
          process.env.MIX_PRICE_PLAN_MONTHLY_WITH_COMMITMENT,
        ],
        monthly_without_commitment: [
          process.env.MIX_OLD_PRICE_PLAN_MONTHLY_WITHOUT_COMMITMENT,
          process.env.MIX_PRICE_PLAN_MONTHLY_WITHOUT_COMMITMENT,
        ],
        pc_client: [process.env.MIX_PRICE_PLAN_CLIENT_PC],
      },
      search: '',

      isPopupEditSubscriptionDisplayed: false,
      subscriptionToEdit: {},

      isPopupEditAdministrateurPayeurDisplayed: false,
      isPopupListAccountsToConnectDisplayed: false,
      adminToEdit: {},
      loading: false,
    };
  },

  async mounted() {
    await this.loadStructures();
    await this.loadParticuliers();
  },

  methods: {
    ...mapMutations({
      SET_LOADING: 'app/SET_LOADING',
    }),

    ...mapActions({
      changeStructure: 'auth/changeStructure',
    }),

    flatUsers(company) {
      return [
        ...company.users?.admin ?? [],
        ...company.users?.manager ?? [],
        ...company.users?.beneficiary ?? []
      ];
    },

    loadStructures() {
      this.loading = true;
      axios
        .get('api/admin/companies')
        .then((response) => {
          this.structures = response.data;
        })
        .catch((err) => {
          console.log('ERRRR:: ', err);
        }).finally(() => {
          this.loading = false;
        });
    },

    loadParticuliers() {
      axios
        .get('api/admin/particuliers')
        .then((response) => {
          this.particuliers = response.data;
        })
        .catch((err) => {
          console.log('ERRRR:: ', err);
        });
    },

    editSubscription(structure) {
      this.subscriptionToEdit = structure;
      this.changeStateEditSubscriptionPopup(true);
    },

    changeStateEditSubscriptionPopup(state) {
      if (!state) {
        this.subscriptionToEdit = {};
      }
      this.isPopupEditSubscriptionDisplayed = state;
    },

    editAdmin(admin) {
      this.adminToEdit = admin;
      this.changeStateEditAdministrateurPayeurPopup(true);
    },

    changeStateEditAdministrateurPayeurPopup(state) {
      if (!state) {
        this.adminToEdit = {};
      }
      this.isPopupEditAdministrateurPayeurDisplayed = state;
    },

    async connectToAccount(user) {
      await axios.get('/sanctum/csrf-cookie');
      await axios
        .get('/admin/connectToAccount/' + user.id)
        .then(async (response) => {
          window.location.replace('/');
        })
        .catch((err) => {
          console.log(err);
        });
    },

    changeStateListAccountsPopup(state, structure = {}) {
      this.isPopupListAccountsToConnectDisplayed = state;
      this.selectedStructure = structure;
    },

    changeTab(tab) {
      this.tabDisplay = tab;
    },
  },

  computed: {
    subscriptions() {
      let subscriptions = new Set();

      for (const company of this.structures) {
        const subscription = company.subscription;
        subscriptions.add(subscription);
      }

      return [...subscriptions];
    },

    structuresFilter: {
      get: function () {
        let filteredList = [];

        filteredList = [...this.structures].filter((structure) =>
          structure.name
            .toLocaleLowerCase()
            .includes(this.search.toLocaleLowerCase())
        );
        return filteredList;
      },
    },

    structuresSort() {
      let sortedList = [];

      if (['ABC', 'ZYX'].includes(this.sort)) {
        sortedList = [...this.structuresFilter].sort(function (a, b) {
          let nameA = a.name.toUpperCase();
          let nameB = b.name.toUpperCase();
          return nameA.localeCompare(nameB);
        });
      }

      if (['JAN', 'DEC'].includes(this.sort)) {
        sortedList = [...this.structuresFilter].sort(function (a, b) {
          let dateA = a.created_at;
          let dateB = b.created_at;
          return dateA.localeCompare(dateB);
        });
      }

      if (['ABC', 'JAN'].includes(this.sort)) {
        return sortedList;
      }
      if (['ZYX', 'DEC'].includes(this.sort)) {
        return sortedList.reverse();
      }
    },

    particuliersFilter: {
      get: function () {
        let filteredList = [];

        filteredList = [...this.particuliers].filter(
          (particulier) =>
            particulier.firstname
              .toLocaleLowerCase()
              .includes(this.search.toLocaleLowerCase()) ||
            particulier.lastname
              .toLocaleLowerCase()
              .includes(this.search.toLocaleLowerCase()) ||
            (
              particulier.firstname.toLocaleLowerCase() +
              ' ' +
              particulier.lastname.toLocaleLowerCase()
            ).includes(this.search.toLocaleLowerCase()) ||
            (
              particulier.lastname.toLocaleLowerCase() +
              ' ' +
              particulier.firstname.toLocaleLowerCase()
            ).includes(this.search.toLocaleLowerCase())
        );
        return filteredList;
      },
    },

    particuliersSort() {
      let sortedList = [];

      if (['ABC', 'ZYX'].includes(this.sort)) {
        sortedList = [...this.particuliersFilter].sort(function (a, b) {
          let nameA = a.lastname.toUpperCase();
          let nameB = b.lastname.toUpperCase();
          return nameA.localeCompare(nameB);
        });
      }

      if (['JAN', 'DEC'].includes(this.sort)) {
        sortedList = [...this.particuliersFilter].sort(function (a, b) {
          let dateA = a.created_at;
          let dateB = b.created_at;
          return dateA.localeCompare(dateB);
        });
      }

      if (['ABC', 'JAN'].includes(this.sort)) {
        return sortedList;
      }
      if (['ZYX', 'DEC'].includes(this.sort)) {
        return sortedList.reverse();
      }
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
